/**
 * DBE Keeper 패턴 — User-Agent 파싱으로 device_label 생성 (Issue #1291).
 *
 * 설계: backend/docs/design/dbe_keeper_pattern_migration.md §4.4
 *
 * Note: User-Agent 는 spoofing 가능 — 정보성 표시(device_label)에만 사용, 보안 결정 X.
 * 서버 측 device_label ≤ 100자 + DOMPurify 적용.
 */

/**
 * navigator.userAgent → "macOS Chrome" 형태 device_label 생성.
 */
export function parseDeviceLabel(ua) {
  return `${parseOs(ua)} ${parseBrowser(ua)}`
}

export function parseOs(ua) {
  if (/iPad/.test(ua)) return 'iPad' // iPad 가 'Mac OS X' UA 포함 — 먼저 검사 (Phase 3a #1154 학습)
  if (/iPhone/.test(ua)) return 'iPhone'
  if (/Mac OS X/.test(ua)) return 'macOS'
  if (/Windows/.test(ua)) return 'Windows'
  if (/Android/.test(ua)) return 'Android' // Android 가 'Linux' UA 포함 — Linux 보다 먼저
  if (/Linux/.test(ua)) return 'Linux'
  return 'Unknown'
}

export function parseBrowser(ua) {
  if (/Edg\//.test(ua)) return 'Edge' // Edge 가 'Chrome/' UA 포함 — 먼저 검사
  if (/Chrome\//.test(ua)) return 'Chrome'
  if (/Safari\//.test(ua) && !/Chrome\//.test(ua)) return 'Safari'
  if (/Firefox\//.test(ua)) return 'Firefox'
  return 'Unknown'
}
